import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
import { s as safeCall } from './overlays.js';
import { g as getClassMap } from './theme.js';
import { d as defineCustomElement$a } from './checkbox.js';
import { d as defineCustomElement$9 } from './icon.js';
import { d as defineCustomElement$8 } from './item.js';
import { d as defineCustomElement$7 } from './label.js';
import { d as defineCustomElement$6 } from './list.js';
import { d as defineCustomElement$5 } from './list-header.js';
import { d as defineCustomElement$4 } from './note.js';
import { d as defineCustomElement$3 } from './radio.js';
import { d as defineCustomElement$2 } from './radio-group.js';
import { d as defineCustomElement$1 } from './ripple-effect.js';
var selectPopoverIosCss = ".sc-ion-select-popover-ios-h ion-list.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-ios,ion-label.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}";
var selectPopoverMdCss = ".sc-ion-select-popover-md-h ion-list.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-md,ion-label.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list.sc-ion-select-popover-md ion-radio.sc-ion-select-popover-md{opacity:0}ion-item.sc-ion-select-popover-md{--inner-border-width:0}.item-radio-checked.sc-ion-select-popover-md{--background:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);--background-focused:var(--ion-color-primary, #3880ff);--background-focused-opacity:0.2;--background-hover:var(--ion-color-primary, #3880ff);--background-hover-opacity:0.12}.item-checkbox-checked.sc-ion-select-popover-md{--background-activated:var(--ion-item-color, var(--ion-text-color, #000));--background-focused:var(--ion-item-color, var(--ion-text-color, #000));--background-hover:var(--ion-item-color, var(--ion-text-color, #000));--color:var(--ion-color-primary, #3880ff)}";

var SelectPopover = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SelectPopover, _HTMLElement);

  var _super = _createSuper(SelectPopover);

  function SelectPopover() {
    var _this;

    _classCallCheck(this, SelectPopover);

    _this = _super.call(this);

    _this.__registerHost();
    /**
     * An array of options for the popover
     */


    _this.options = [];
    return _this;
  }

  _createClass(SelectPopover, [{
    key: "onSelect",
    value: function onSelect(ev) {
      this.setChecked(ev);
      this.callOptionHandler(ev);
    }
  }, {
    key: "findOptionFromEvent",
    value: function findOptionFromEvent(ev) {
      var options = this.options;
      return options.find(function (o) {
        return o.value === ev.target.value;
      });
    }
    /**
     * When an option is selected we need to get the value(s)
     * of the selected option(s) and return it in the option
     * handler
     */

  }, {
    key: "callOptionHandler",
    value: function callOptionHandler(ev) {
      var option = this.findOptionFromEvent(ev);
      var values = this.getValues(ev);

      if (option && option.handler) {
        safeCall(option.handler, values);
      }
    }
    /**
     * This is required when selecting a radio that is already
     * selected because it will not trigger the ionChange event
     * but we still want to close the popover
     */

  }, {
    key: "rbClick",
    value: function rbClick(ev) {
      this.callOptionHandler(ev);
    }
  }, {
    key: "setChecked",
    value: function setChecked(ev) {
      var multiple = this.multiple;
      var option = this.findOptionFromEvent(ev); // this is a popover with checkboxes (multiple value select)
      // we need to set the checked value for this option

      if (multiple && option) {
        option.checked = ev.detail.checked;
      }
    }
  }, {
    key: "getValues",
    value: function getValues(ev) {
      var multiple = this.multiple,
          options = this.options;

      if (multiple) {
        // this is a popover with checkboxes (multiple value select)
        // return an array of all the checked values
        return options.filter(function (o) {
          return o.checked;
        }).map(function (o) {
          return o.value;
        });
      } // this is a popover with radio buttons (single value select)
      // return the value that was clicked, otherwise undefined


      var option = this.findOptionFromEvent(ev);
      return option ? option.value : undefined;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options) {
      var multiple = this.multiple;

      switch (multiple) {
        case true:
          return this.renderCheckboxOptions(options);

        default:
          return this.renderRadioOptions(options);
      }
    }
  }, {
    key: "renderCheckboxOptions",
    value: function renderCheckboxOptions(options) {
      return options.map(function (option) {
        return h("ion-item", {
          class: getClassMap(option.cssClass)
        }, h("ion-checkbox", {
          slot: "start",
          value: option.value,
          disabled: option.disabled,
          checked: option.checked
        }), h("ion-label", null, option.text));
      });
    }
  }, {
    key: "renderRadioOptions",
    value: function renderRadioOptions(options) {
      var _this2 = this;

      var checked = options.filter(function (o) {
        return o.checked;
      }).map(function (o) {
        return o.value;
      })[0];
      return h("ion-radio-group", {
        value: checked
      }, options.map(function (option) {
        return h("ion-item", {
          class: getClassMap(option.cssClass)
        }, h("ion-label", null, option.text), h("ion-radio", {
          value: option.value,
          disabled: option.disabled,
          onClick: function onClick(ev) {
            return _this2.rbClick(ev);
          }
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var header = this.header,
          message = this.message,
          options = this.options,
          subHeader = this.subHeader;
      var hasSubHeaderOrMessage = subHeader !== undefined || message !== undefined;
      return h(Host, {
        class: getIonMode(this)
      }, h("ion-list", null, header !== undefined && h("ion-list-header", null, header), hasSubHeaderOrMessage && h("ion-item", null, h("ion-label", {
        class: "ion-text-wrap"
      }, subHeader !== undefined && h("h3", null, subHeader), message !== undefined && h("p", null, message))), this.renderOptions(options)));
    }
  }], [{
    key: "style",
    get: function get() {
      return {
        ios: selectPopoverIosCss,
        md: selectPopoverMdCss
      };
    }
  }]);

  return SelectPopover;
}(HTMLElement);

SelectPopover = /*@__PURE__*/proxyCustomElement(SelectPopover, [34, "ion-select-popover", {
  "header": [1],
  "subHeader": [1, "sub-header"],
  "message": [1],
  "multiple": [4],
  "options": [16]
}, [[0, "ionChange", "onSelect"]]]);

function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-select-popover", "ion-checkbox", "ion-icon", "ion-item", "ion-label", "ion-list", "ion-list-header", "ion-note", "ion-radio", "ion-radio-group", "ion-ripple-effect"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-select-popover":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, SelectPopover);
        }

        break;

      case "ion-checkbox":
        if (!customElements.get(tagName)) {
          defineCustomElement$a();
        }

        break;

      case "ion-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$9();
        }

        break;

      case "ion-item":
        if (!customElements.get(tagName)) {
          defineCustomElement$8();
        }

        break;

      case "ion-label":
        if (!customElements.get(tagName)) {
          defineCustomElement$7();
        }

        break;

      case "ion-list":
        if (!customElements.get(tagName)) {
          defineCustomElement$6();
        }

        break;

      case "ion-list-header":
        if (!customElements.get(tagName)) {
          defineCustomElement$5();
        }

        break;

      case "ion-note":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }

        break;

      case "ion-radio":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }

        break;

      case "ion-radio-group":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;

      case "ion-ripple-effect":
        if (!customElements.get(tagName)) {
          defineCustomElement$1();
        }

        break;
    }
  });
}

export { SelectPopover as S, defineCustomElement as d };